module.exports = __webpack_public_path__ + "img/@logo_lsmtron.b5437741.jpg";